import Menu from "../../ui/Menu";
import styled from "@emotion/styled/macro";
import SecondaryMenu from "../../ui/SecondaryMenu/SecondaryMenu";
import LanguageBox from "../../ui/LanguageBox"
import { useTheme } from "@chakra-ui/react";
const Wrapper = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.opal};
  padding: 25px 20px;
  overflow : auto;
`;

const MenuWrapper = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }

  ul {
    list-style-type: none;
    max-width: 90%;
  }

  li {
    border-bottom: 1px solid ${({ theme }) => theme.colors.opal};
    padding: 0.6em 0;
  }
`;
const SecondMenuWrapper = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }
  ul {
    padding : 2.12em 0;
    list-style-type: none;
    max-width: 90%;
  }
  li {color: ${({ theme }) => theme.colors.primary};
    padding: 0.6em 0;
  }
`;

const VerticalMenu = ({ onClose }) => {
  const theme = useTheme();
  return (
    <Wrapper>
      <MenuWrapper>
        <Menu onClose={onClose} />
      </MenuWrapper>
      <SecondMenuWrapper>
        <SecondaryMenu onClose={onClose}/>
        <LanguageBox colorTheme={theme.colors.opal} />
      </SecondMenuWrapper>

    </Wrapper>
  );
};

export default VerticalMenu;
